















































































































































































































import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import * as Constants from '@/constants.ts';
import Vue from 'vue';

interface CategoryChargeSplitApi {
  [key: string]: CategoryCharge;
}

type CategoryChargeSplit = CategoryChargeSplitApi & {
  splitIndex: number;
};

function initialState() {
  return {
    splitQuantity: 2,
    selectedSplit: 1,
    aSplitArrayIsEmpty: true,
    requestBillDisabled: true,
    showPaymentForm: false,
    choseInAppPayment: false,
    showPaymentButton: false,
    currSelectedBillType: null,
    currBillType: null,
    currBillTotal: 0,
    orderItemsForPartialBill: [],
    categoryChargesForPartialOrFullBill: [],
    orderItemForSplitBill: [[], []], // Array of split arrays containing order item ids.
    categoryChargeForSplitBill: [{ splitIndex: 1 }, { splitIndex: 2 }], // Array of split objects containing CategoryCharges as values, indexed on category id.
    currSelectedBill: {},
    currOrderItemsForRequest: [] as OrderItem[] | OrderItem[][],
    currCategoryChargesForRequest: [] as CategoryCharge[] | CategoryCharge[][],
    categoryPaymentQuantity: {},
    ordersForCurrentPaymentCharge: [],
  };
}

export default Vue.extend({
  data() {
    return {
      ...initialState(),
      eBillTypes: Enums.eBillTypes,
      eNotificationStatuses: Enums.eNotificationStatuses,
    };
  },
  computed: {
    tablesidePaymentsEnabled(): boolean {
      return Util.isFeatureEnabled(this.$store.state.featureFlags.tablesidePaymentsEnabled);
    },
    isTakeoutMode(): boolean {
      return this.$store.state.appMode === Enums.eAppModes.takeout;
    },
    tablesideAcceptedOrdersNotAddedToABill(): OrderItem[] {
      // Orders that have a bill id are already in a requested bill.
      return this.$store.getters.tablesideUnpaidOrders.filter((unpaidOrder: OrderItem) => !unpaidOrder.billId && !unpaidOrder.billId);
    },
    tablesideAcceptedOrdersNotAddedToABillToShow(): OrderItem[] {
      // Only show order items that actually cost something. We can't charge for free things.
      return this.tablesideAcceptedOrdersNotAddedToABill.filter((unpaidAndNonBilledOrder: OrderItem) => unpaidAndNonBilledOrder.totalPrice);
    },
    allItemsStillToBeChargedForLength(): number {
      return this.tablesideAcceptedOrdersNotAddedToABillToShow.length + this.categoriesToBeChargedFor.length;
    },
    formattedBillTotal(): string {
      return `<span class="bold">${Util.formatCurrency(this.$data.currBillTotal)}</span>`;
    },
    tablesidePaidOrders(): OrderItem[] {
      return this.$store.getters.tablesidePaidOrders;
    },
    pendingBills(): OrderItem[] {
      return this.$store.state.currentUserEstablishmentExchangeObject.pendingBills;
    },
    acceptedBills(): OrderItem[] {
      return this.$store.state.currentUserEstablishmentExchangeObject.acceptedBills;
    },
    rejectedBills(): OrderItem[] {
      return this.$store.state.currentUserEstablishmentExchangeObject.rejectedBills;
    },
    cancelledBills(): OrderItem[] {
      return this.$store.state.currentUserEstablishmentExchangeObject.cancelledBills;
    },
    categoriesToBeChargedFor(): MenuCategory[] {
      const tablesideAcceptedOrdersMenuItemIds = this.$store.getters.tablesideAcceptedOrders.map((oi: OrderItem) => oi.menuItemDocId);
      return this.$store.state.currentMenu.categories.filter((cat: MenuCategory) => {
        if (cat.price && cat.menuItems.some((mi: MenuItem) => tablesideAcceptedOrdersMenuItemIds.includes(mi.docId as string))) {
          this.$data.categoryPaymentQuantity[cat.docId as string] = 0;
          return true;
        }
        return false;
      });
    },
  },
  methods: {
    onPayForSomeoneElse() {
      // TODO.
    },
    onPaymentReady() {
      this.$data.showPaymentButton = true;
    },
    onPaymentNotReady() {
      this.$data.showPaymentButton = false;
    },
    changeSelectedSplit(num: number) {
      this.$data.selectedSplit = num;
      for (const catId of Object.keys(this.$data.categoryPaymentQuantity)) {
        const currCategoryCharge = this.$data.categoryChargeForSplitBill[num - 1][catId];
        this.$data.categoryPaymentQuantity[catId] = currCategoryCharge ? currCategoryCharge.quantity : 0;
      }
    },
    openBillDetailsModal(bill: Bill, type: string) {
      this.$data.currSelectedBill = bill;
      this.$data.currSelectedBillType = type;
      Util.routerPush({ path: Constants.allRoutes.billDetailsModal });
    },
    formatCurrency(price: number, showSign: boolean = false): string {
      return Util.formatCurrency(price, showSign);
    },
    onSendBillRequest() {
      const tablesideAcceptedOrders: OrderItem[] = this.$store.getters.tablesideAcceptedOrders || [];
      const billId = Util.generateId();
      const notificationId = Util.generateId();
      let bill: Bill = {
        billId,
        notificationId,
        total: this.$data.currBillTotal,
      };
      const update: any = {};
      update.pendingBills = this.$store.state.currentUserEstablishmentExchangeObject.pendingBills || [];

      switch (this.$data.currBillType) {
        case Enums.eBillTypes.full:
          bill.orderItems = [...this.$data.currOrderItemsForRequest];
          bill.categoryCharges = [...this.$data.currCategoryChargesForRequest];
          update.tablesideAcceptedOrders = [...tablesideAcceptedOrders].map((ao: OrderItem) => {
            if (!ao.billId) {
              // Put billId into remaining unbilled accepted orders.
              return {
                ...ao,
                billId,
              };
            }
            return ao;
          });
          break;
        case Enums.eBillTypes.partial:
          bill.orderItems = [...this.$data.currOrderItemsForRequest];
          bill.categoryCharges = [...this.$data.currCategoryChargesForRequest];
          update.tablesideAcceptedOrders = [...tablesideAcceptedOrders].map((ao: OrderItem) => {
            if (this.$data.orderItemsForPartialBill.includes(ao.orderItemId)) {
              // If the accepted order is in the partial bill.
              return {
                ...ao,
                billId,
              };
            }
            return ao;
          });
          break;
        case Enums.eBillTypes.split:
          const splitOrderItems: any = {};
          this.$data.currOrderItemsForRequest.forEach((orderItemSplitArray: OrderItem[], i: number) => {
            if (orderItemSplitArray.length) {
              splitOrderItems['split' + i] = orderItemSplitArray;
            }
          });
          bill.splitOrderItems = splitOrderItems;

          const splitCategoryCharges: any = {};
          this.$data.currCategoryChargesForRequest.forEach((categoryChargeSplitArray: CategoryCharge[], i: number) => {
            if (categoryChargeSplitArray.length) {
              splitCategoryCharges['split' + i] = categoryChargeSplitArray;
            }
          });
          bill.splitCategoryCharges = splitCategoryCharges;

          update.tablesideAcceptedOrders = [...tablesideAcceptedOrders].map((ao: OrderItem) => {
            if (this.$data.orderItemForSplitBill.some((splitArray: string[]) => splitArray.includes(ao.orderItemId as string))) {
              // If the accepted order is in the partial bill.
              return {
                ...ao,
                billId,
              };
            }
            return ao;
          });
          break;
      }

      bill = Util.removeFalsyExceptZero(bill);

      const notification: BillNotification = {
        notificationId,
        status: Enums.eNotificationStatuses.pending,
        type: Enums.eNotificationTypes.bill,
        bill,
      };

      update.pendingBills.push(bill);

      Util.sendNotificationToEstablishment(notification, update);
      this.onCloseBillModal();
    },
    nonEmptycategoryChargeForSplitBill(catId: string) {
      return this.$data.categoryChargeForSplitBill.filter((ccs: CategoryChargeSplit) => Object.keys(ccs).includes(catId));
    },
    onLowerCategoryChargeQuantity(category: MenuCategory) {
      this.$data.categoryPaymentQuantity[category.docId]--;
      this.onCategoryChargeQuantityChange(category);
      this.$forceUpdate();
    },
    onRaiseCategoryChargeQuantity(category: MenuCategory) {
      this.$data.categoryPaymentQuantity[category.docId]++;
      this.onCategoryChargeQuantityChange(category);
      this.$forceUpdate();
    },
    onLowerQuantity() {
      if (this.$data.splitQuantity > 2) {
        this.$data.splitQuantity--;
        this.selectedSplit = this.selectedSplit > this.$data.splitQuantity ? 1 : this.selectedSplit; // Go back to the first split being selected if the current split was removed.
        this.orderItemForSplitBill.pop();
        this.categoryChargeForSplitBill.pop();
      }
    },
    onRaiseQuantity() {
      if (this.$data.splitQuantity < 99) {
        this.$data.splitQuantity++;
        this.orderItemForSplitBill.push([]);
        this.categoryChargeForSplitBill.push({ splitIndex: this.$data.splitQuantity });
      }
    },
    openBillModalForPayment(type: number) {
      this.$data.choseInAppPayment = true;
      switch (type) {
        case Enums.eBillTypes.full:
          this.$data.ordersForCurrentPaymentCharge = [...this.tablesideAcceptedOrdersNotAddedToABillToShow];
          break;
        case Enums.eBillTypes.partial:
          this.$data.ordersForCurrentPaymentCharge = [];
          break;
      }
      this.openBillModal(type);
    },
    openBillModal(type: number) {
      this.$data.currBillType = type;
      Util.routerPush({ path: Constants.allRoutes.billModal });
      this.computeBillForRequest();
    },
    onCloseBillModal() {
      const initialStateCopy: any = initialState();
      for (const prop of Object.keys(initialStateCopy)) {
        this.$data[prop] = initialStateCopy[prop];
      }
      this.$router.go(-1);
    },
    onCategoryChargeQuantityChange(category: MenuCategory) {
      const catId = category.docId;
      const totalPrice = this.$data.categoryPaymentQuantity[catId] * category.price;
      const totalPriceWithTax = Math.round(this.$data.categoryPaymentQuantity[catId] * Util.getPostTaxAmountForGenericCharge(category.price));

      const newCategoryCharge: CategoryCharge = {
        categoryId: catId,
        name: category.name,
        quantity: this.$data.categoryPaymentQuantity[catId],
        totalPrice,
        totalPriceWithTax,
      };

      switch (this.$data.currBillType) {
        case Enums.eBillTypes.full:
        case Enums.eBillTypes.partial:
          if (this.$data.categoryPaymentQuantity[catId] === 0) {
            delete this.$data.categoryChargesForPartialOrFullBill[catId];
          } else {
            this.$data.categoryChargesForPartialOrFullBill[catId] = newCategoryCharge;
          }
          break;
        case Enums.eBillTypes.split:
          const currSplitIndex = this.$data.selectedSplit - 1;
          const currSplitArray = this.$data.categoryChargeForSplitBill[currSplitIndex];
          if (this.$data.categoryPaymentQuantity[catId] === 0) {
            delete currSplitArray[catId];
          } else {
            currSplitArray[catId] = newCategoryCharge;
          }
          break;
      }
      this.computeBillForRequest();
    },
    onNotAlreadyBilledForOrderItemClick(orderItemId: string) {
      switch (this.$data.currBillType) {
        case Enums.eBillTypes.partial:
          if (this.$data.orderItemsForPartialBill.includes(orderItemId)) {
            this.$data.orderItemsForPartialBill = this.$data.orderItemsForPartialBill.filter((str: string) => str !== orderItemId);
          } else {
            this.$data.orderItemsForPartialBill.push(orderItemId);
          }
          if (this.$data.choseInAppPayment) {
            this.$data.ordersForCurrentPaymentCharge = this.tablesideAcceptedOrdersNotAddedToABill.filter((ao: OrderItem) => this.$data.orderItemsForPartialBill.includes(ao.orderItemId));
          }
          break;
        case Enums.eBillTypes.split:
          const currSplitIndex = this.$data.selectedSplit - 1;
          const currSplitArray = this.$data.orderItemForSplitBill[currSplitIndex];
          let oldSplitArrayIndex = -1;
          const existsInAnotherArray = this.$data.orderItemForSplitBill.some((splitArray: string[], i: number) => {
            oldSplitArrayIndex = i;
            return i === currSplitIndex ? false : splitArray.includes(orderItemId);
          });
          if (!existsInAnotherArray) {
            if (currSplitArray.includes(orderItemId)) {
              // Remove from current split.
              this.$data.orderItemForSplitBill[currSplitIndex] = currSplitArray.filter((str: string) => str !== orderItemId);
            } else {
              // Add to current split.
              currSplitArray.push(orderItemId);
            }
          } else {
            // Remove from other split array and add to the current one.
            this.$data.orderItemForSplitBill[oldSplitArrayIndex] = this.$data.orderItemForSplitBill[oldSplitArrayIndex].filter((str: string) => str !== orderItemId);
            currSplitArray.push(orderItemId);
          }
          break;
      }
      this.computeBillForRequest();
    },
    computeBillForRequest() {
      let billOrderItemArray: any = [];
      let billCategoryChargeArray: any = [];
      switch (this.$data.currBillType) {
        case Enums.eBillTypes.full:
          // If reuqesting the full bill then just add all non added orders to the bill
          billOrderItemArray = [...this.tablesideAcceptedOrdersNotAddedToABill];
          // As welll as all category charges.
          billCategoryChargeArray = Object.values(this.$data.categoryChargesForPartialOrFullBill);
          break;
        case Enums.eBillTypes.partial:
          // If requesting a partial bill only add accepted orders not added to the bill that have an orderItemId in orderItemsForPartialBill.
          billOrderItemArray = this.tablesideAcceptedOrdersNotAddedToABill.filter((ao: OrderItem) => this.$data.orderItemsForPartialBill.includes(ao.orderItemId));
          billCategoryChargeArray = Object.values(this.$data.categoryChargesForPartialOrFullBill);
          break;
        case Enums.eBillTypes.split:
          billOrderItemArray = [...this.$data.orderItemForSplitBill];
          billOrderItemArray.forEach((splitArray: string[], i: number) => {
            billOrderItemArray[i] = splitArray.map((orderItemId: string) => {
              return this.tablesideAcceptedOrdersNotAddedToABill.filter((ao: OrderItem) => ao.orderItemId === orderItemId)[0];
            });
          });
          billCategoryChargeArray = [...this.$data.categoryChargeForSplitBill];
          billCategoryChargeArray.forEach((splitObj: CategoryChargeSplit, i: number) => {
            const splitObjCopy = { ...splitObj };
            delete splitObjCopy.splitIndex;
            const splitObjCopyArray = Object.values(splitObjCopy);
            billCategoryChargeArray[i] = Object.values(splitObjCopy);
          });
          break;
      }

      this.$data.currOrderItemsForRequest = billOrderItemArray;
      this.$data.currCategoryChargesForRequest = billCategoryChargeArray;
      this.$data.currBillTotal = 0;

      // Increase total based on order items.
      if (billOrderItemArray.length) {
        if (Array.isArray(billOrderItemArray[0])) {
          this.$data.currBillTotal += billOrderItemArray.reduce((total: number, orderItemSplitArray: OrderItem[]) => {
            return (
              total +
              orderItemSplitArray.reduce((subTotal: number, oi: OrderItem) => {
                return subTotal + oi.totalPriceWithTax;
              }, 0)
            );
          }, 0);
        } else {
          this.$data.currBillTotal += billOrderItemArray.reduce((total: number, oi: OrderItem) => {
            return total + oi.totalPriceWithTax;
          }, 0);
        }
      }

      // Increase total based on category charges.
      if (billCategoryChargeArray.length) {
        if (Array.isArray(billCategoryChargeArray[0])) {
          this.$data.currBillTotal += billCategoryChargeArray.reduce((total: number, categoryChargeSplitArray: CategoryCharge[]) => {
            return (
              total +
              categoryChargeSplitArray.reduce((subTotal: number, cc: CategoryCharge) => {
                return subTotal + cc.totalPriceWithTax;
              }, 0)
            );
          }, 0);
        } else {
          this.$data.currBillTotal += billCategoryChargeArray.reduce((total: number, cc: CategoryCharge) => {
            return total + cc.totalPriceWithTax;
          }, 0);
        }
      }

      this.computeRequestedBillDisabled();
      this.$forceUpdate();
    },
    computeRequestedBillDisabled() {
      this.$data.requestBillDisabled = false;

      switch (this.$data.currBillType) {
        case Enums.eBillTypes.partial:
          this.$data.requestBillDisabled = !this.$data.currOrderItemsForRequest.length && !this.$data.currCategoryChargesForRequest.length;
          break;
        case Enums.eBillTypes.split:
          this.$data.aSplitArrayIsEmpty = false;
          for (let i = 0; i < this.$data.splitQuantity; i++) {
            const orderItemSplit = this.$data.currOrderItemsForRequest[i];
            const categoryChargeSplit = this.$data.currCategoryChargesForRequest[i];
            this.$data.aSplitArrayIsEmpty = !orderItemSplit.length && !categoryChargeSplit.length;
            if (this.$data.aSplitArrayIsEmpty) {
              this.$data.requestBillDisabled = true;
              break;
            }
          }
          break;
      }
    },
    getCategoryTagTextForSplit(ccs: CategoryChargeSplit, catId: string): string {
      const chargeNum = ccs[catId].quantity;
      return chargeNum ? (chargeNum > 1 ? Util.t?.chargeNumAddedToSplitPlural : Util.t?.chargeNumAddedToSplitSingular).supplant([chargeNum, ccs.splitIndex]) : '';
    },
    getOrderItemTagText(orderItemId: string): string {
      switch (this.$data.currBillType) {
        case Enums.eBillTypes.partial:
          if (this.$data.orderItemsForPartialBill.includes(orderItemId)) {
            return Util.t?.orderItemAddedToPartialBill;
          }
          break;
        case Enums.eBillTypes.split:
          const splits = this.$data.orderItemForSplitBill;
          let inSplit = -1;
          splits.some((splitArray: string[], i: number) => {
            if (splitArray.includes(orderItemId)) {
              inSplit = i + 1;
              return true;
            }
            return false;
          });
          return inSplit === -1 ? '' : Util.t?.orderItemAddedToSplit.supplant([inSplit]);
          break;
      }
      return '';
    },
    sendPaymentToStripe() {
      if (this.$store.state.currentClientUser) {
        (this.$refs.stripePayment as any).onCardPaymentSubmit();
      } else {
        Util.showError(Util.t?.mustBeSignedIn);
      }
    },
  },
});
